<template>
  <div class="contract-files">
    <div class="custom-header">
      <base-button
        class="elite-button add"
        icon
        size="sm"
        @click="openAddFileModal"
        v-if="$currentUserCan($permissions.PERM_CREATE_CONTRACT_FILES)"
      >
        <span class="btn-inner--icon">
          <i class="far fa-plus-circle"></i>
        </span>
        <span class="btn-inner--text">
          {{ $t("CONTRACTS.ADD_FILE") }}
        </span>
      </base-button>
    </div>

    <file-list-table
      :key="renderKey"
      v-if="contract.id"
      :contract="contract"
      @onEditFile="openEditFileModal"
      @onDeleteFile="deleteFile"
      @onViewFile="openViewFileModal"
    />

    <file-add-form-modal
      v-if="contract.id"
      :showModal="showAddFormModal"
      :contract="contract"
      @onCloseModal="closeModal"
    />

    <file-edit-form-modal
      v-if="contract.id"
      :showModal="showEditFormModal"
      :fileData="file"
      @onCloseModal="closeModal"
    />

    <file-view-modal
      v-if="contract.id"
      :showModal="showViewModal"
      :fileData="file"
      @onCloseModal="closeModal"
      @fileUpdated="refreshFile"
      @editFile="
        (id) => {
          closeModal(false);
          openEditFileModal(id);
        }
      "
      @deleteFile="
        (id) => {
          closeModal(false);
          deleteFile(id);
        }
      "
    />
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
import { Button } from "element-ui";
import swal from "sweetalert2";
import FileListTable from "./partials/FileListTable.vue";
import defaultContractFile from "./defaultContractFile";
import FileAddFormModal from "./partials/FileAddFormModal.vue";
import FileEditFormModal from "./partials/FileEditFormModal.vue";
import FileViewModal from "./partials/FileViewModal.vue";

export default {
  components: {
    FileListTable,
    FileAddFormModal,
    FileEditFormModal,
    FileViewModal,
    [Button.name]: Button,
  },

  mixins: [],

  props: {
    contract: {
      type: Object,
      default: null,
      description: "Files linked contract",
    },
  },

  computed: {},

  watch: {},

  data() {
    return {
      renderKey: 0,
      file: cloneDeep(defaultContractFile),
      showAddFormModal: false,
      showEditFormModal: false,
      showViewModal: false,
    };
  },

  methods: {
    openAddFileModal() {
      this.showAddFormModal = true;
    },

    async openEditFileModal(id) {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      await this.$store.dispatch("contractFiles/get", id);
      this.file = this.$store.getters["contractFiles/file"];
      this.showEditFormModal = true;
      swal.close();
    },

    async openViewFileModal(id) {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      await this.$store.dispatch("contractFiles/get", id);
      this.file = this.$store.getters["contractFiles/file"];
      this.showViewModal = true;
      swal.close();
    },

    closeModal(refresh = false) {
      this.showAddFormModal = false;
      this.showEditFormModal = false;
      this.showViewModal = false;
      this.file = cloneDeep(defaultContractFile);
      if (refresh) {
        this.renderKey = this.renderKey + 1;
      }
    },

    async refreshFile() {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      await this.$store.dispatch("contractFiles/get", this.file.id);
      this.file = this.$store.getters["contractFiles/file"];
      swal.close();
    },

    async deleteFile(id) {
      const confirmation = await swal.fire({
        text: this.$t("CONTRACTS.DELETE_THIS_FILE"),
        type: "question",
        customClass: {
          popup: "delete-popup",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            onOpen: () => {
              swal.showLoading();
            },
          });
          await this.$store.dispatch("contractFiles/destroy", id);
          this.$notify({
            type: "success",
            message: this.$t("CONTRACTS.FILE_DELETED"),
          });
          this.closeModal(true);
          swal.close();
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
